import SuggestNewCouponPage from 'components/pages/SuggestNewCoupon';

const SuggestNewCoupon = (props) => <SuggestNewCouponPage {...props} />;

export default SuggestNewCoupon;
